import React, { useEffect, useState } from 'react'
import { useAppEx, useTbViewStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import { listToTableWithCount, listToTree } from '@ow/utils'
import { SearchTree } from '@ow/comps'

const renderTitle = (item) => {
  return <div>({item.count})</div>
}

const Areas = function () {
  const [data, setData] = useState([])
  const [treeData, setTreeData] = useState([])

  const { getDitto } = useAppEx((state) => pick(state, ['getDitto']))

  const { clickedInfo, filters, setFilters, ditto, setClickedInfo } =
    useTbViewStore((state) =>
      pick(state, [
        'clickedInfo',
        'filters',
        'setFilters',
        'ditto',
        'setClickedInfo',
      ])
    )
  const { clickedId = null } = clickedInfo

  const fetchCount = async (list) => {
    const count = await ditto.fetchCountGroupBy('area', {
      filters,
    })
    const countMap = listToTableWithCount(
      list.map((v) => {
        return { ...v, id: v.objectId }
      }),
      null,
      count.area
    )
    list.forEach((d) => {
      d.count = countMap[d.objectId] || 0
    })

    const tree = listToTree(
      list.map((v) => {
        return { ...v, id: v.objectId }
      })
    )

    setTreeData(tree)
  }

  const fetchTree = async () => {
    const _data = await getDitto('area').fetchTbData({
      pageSize: 30000,
      sorts: [
        {
          desc: false,
          slug: 'childOrder',
        },
      ],
    })
    console.log('areaddd---', _data)
    setData(_data)
    fetchCount(_data)
  }

  useEffect(() => {
    fetchTree()
  }, [])

  useEffect(() => {
    fetchCount(data)
  }, [filters])

  useEffect(() => {
    const queries = {
      logicType: 'and',
      queries: [
        {
          slug: 'area',
          value: clickedId,
          queryType: ['equal'],
        },
      ],
    }
    if (clickedId) {
      setFilters(queries)
    } else if (Object.keys(filters).length !== 0) {
      const _queries = filters.queries.filter((que) => {
        return que.slug !== 'area'
      })
      filters.queries = _queries
      setFilters(filters)
    }
  }, [clickedId])

  return (
    <div style={{ width: '100%', height: '100%' }} className="pt-4">
      <SearchTree
        data={treeData}
        label="title"
        ckey="objectId"
        titleLength={50}
        height="calc(100vh - 290px)"
        otherTitle={(item) => {
          return renderTitle(item)
        }}
        onSelect={(key) => {
          setClickedInfo({
            ...clickedInfo,
            clickedId: key[0] || null,
          })
        }}
      />
    </div>
  )
}

export default Areas
